module.exports = __webpack_public_path__ + "static/sec_one_pic-c61d44fb2673e8968a86f77cf1778a7f.png";